import React, { createContext, useState, useContext, ReactNode } from 'react';

// Types for the context's value
interface ConversionContextType {
  precision: number;
  setPrecision: (val: number) => void;
  exponent: boolean;
  setExponent: (val: boolean) => void;
}

// Create a provider component
interface ConversionsProviderProps {
  children: ReactNode;
}

// Create a Context
const ConversionContext = createContext<ConversionContextType | undefined>(undefined);


// Create a provider component
export const ConversionProvider: React.FC<ConversionsProviderProps> = ({ children }) => {
  const [precision, setPrecision] = useState(4);
  const [exponent, setExponent] = useState(false);

  return (
    <ConversionContext.Provider value={{
      precision,
      setPrecision,
      exponent,
      setExponent
    }}>
      {children}
    </ConversionContext.Provider>
  );
};


// Create a custom hook to use the ConversionContext
export const useConversion = (): ConversionContextType => {
  const context = useContext(ConversionContext);

  if (!context) {
    throw new Error('useConversion must be used within a ConversionProvider');
  }
  return context;
};
